"use strict";

import { Container } from "./container.js";
import { Screen } from "../../systems/core/screen.js";

export class BaseContainer extends Container {
    constructor(config) {
        super(config);

        this.onResolutionChanged();
    }

    getRealWorldPosition() {
        return this.getWorldPosition();
    }
    setRealWorldPosition(x,y) {
        this.setWorldPosition(x,y);
    }
    setWorldPosition(x,y) {
        this._tPosition.x = x.x ?? x;
        this._tPosition.y = x.y ?? y;
        this._tPosition = this.parentContainer.toLocal(this._tPosition);
        
        this.anchoring.margin.x = this._tPosition.x;
        this.anchoring.margin.y = this._tPosition.y;

        this._refreshPosition();
    }
    getWorldPosition() {
        return this.parentContainer.toGlobal(this.getPosition());
    }

    get lossyScaleX() {
        return this.scale.x;
    }
    get lossyScaleY() {
        return this.scale.y;
    }
    get lossyScale() {
        return this.lossyScaleY;
    }

    get externalBounds() {
        return Screen.main.size.bounds;
    }
    set externalBounds(value) {
    }
    get unscaledExternalBounds() {
        return Vector2.multiplySize(this.externalBounds, this.scale.y / this.lossyScale);
    }
}